import { render, staticRenderFns } from "./file-upload-widget.vue?vue&type=template&id=3e086f82&scoped=true&"
import script from "./file-upload-widget.vue?vue&type=script&lang=js&"
export * from "./file-upload-widget.vue?vue&type=script&lang=js&"
import style0 from "./file-upload-widget.vue?vue&type=style&index=0&id=3e086f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e086f82",
  null
  
)

export default component.exports